<template>
  <div class="app-container">
    <div class="topSearch">
      <el-card class="box-card">
        <el-form :model="baseConfig.query.formParams" class="page-query-form" :ref="baseConfig.query.ref"
          :size="baseConfig.query.size" :inline="baseConfig.query.inline">
          <el-form-item v-for="(item, index) in baseConfig.query.formItemList" :key="index" :label="item.label"
            :prop="item.field">
            <el-input v-if="item.type == 'input'" v-model="baseConfig.query.formParams[item.field]"
              :placeholder="item.placeholder" filterable clearable @keyup.enter.native="$emit('queryChange', item)" />

            <el-select v-if="item.type == 'select' && !item.isVirtual" v-model="baseConfig.query.formParams[item.field]"
              :placeholder="item.placeholder" filterable v-select-blur clearable @change="$emit('queryChange', item)">
              <el-option v-for="(option) in item.data" :key="option.value" :label="option.label" :value="option.value">
              </el-option>
            </el-select>

            <insuplc v-if="item.type == 'select' && !!item.isVirtual" @change="$emit('queryChange', item)"
              :defaultValue="baseConfig.query.formParams[item.field]" :params="baseConfig.query.formParams"
              :field="item.field" :list="item.data" class="virtualselect2" :isMultiple="false"
              style="display:inline-block;width: 100%;" :placeholder="item.placeholder" />

            <a-tree-select v-if="item.type == 'treeSelect'" v-model="baseConfig.query.formParams[item.field]"
              style="width: 144px;" :replaceFields="{
                children: 'children', title: 'name', key: 'id', value: 'id'
              }" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :placeholder="item.placeholder" allow-clear
              tree-default-expand-all :tree-data="item.data" tree-node-filter-prop="label">
              <template #title="{ value: val, label }">
                <template>{{ label }}</template>
              </template>
            </a-tree-select>


            <el-date-picker v-if="item.type == 'timePicker'" start-placeholder="开始日期" end-placeholder="结束日期"
              v-model="baseConfig.query.formParams[item.field]" :type="item.timeType" :value-format="item.format"
              :format="item.format" :placeholder="item.placeholder || '开始时间'">
            </el-date-picker>

          </el-form-item>

          <el-button @click="searchBtnClick({
            eventName: 'search'
          })" :v-has-btn="baseConfig.query.permission" size="mini" type="primary" icon="el-icon-search"
            style="margin-bottom: 18px;">查询</el-button>

        </el-form>

      </el-card>
    </div>

    <el-card class="box-card table-card">
      <div slot="header" class="" style="display: flex;justify-content: space-between;align-items: center;">
        <span class="tableTotal">数据列表：{{ baseConfig.table.tableParams.total }} 条</span>
        <div class="toolBtn">
          <template v-for="btn in baseConfig.query.formBtns">
            <el-button v-if="(baseConfig.table.tableData.length === 0 && btn.noDataShow) || !btn.noDataShow"
              @click="searchBtnClick(btn)" :type="btn.type" :icon="btn.icon" :plain="btn.plain"
              v-has-btn="btn.permission" :size="btn.size || 'mini'" style="">{{
                btn.name
              }}</el-button>

          </template>
        </div>
      </div>

      <el-table v-loading="baseConfig.table.loading" :border="true" :data="baseConfig.table.tableData"
        ref="multipleTable" @row-click="$emit('rowClick', $event)" :height="baseConfig.table.height"
        @select="handleSelectionChange" @select-all="handleAllChange" :row-key="(row) => { return row[selectField] }">
        <template v-for="column in baseConfig.table.colunms">

          <el-table-column v-if="!column.specialName && !!column.type" :prop="column.prop" :type="column.type" :fixed="column.fixed"
            :label="column.label" :width="column.width" :align="column.align">
          </el-table-column>

          <el-table-column v-if="!column.specialName && !column.type" :prop="column.prop" :type="column.type" :fixed="column.fixed"
            :label="column.label" :width="column.width" :align="column.align">

            <template #default="scoped">
              <div v-if="!column.fieldMap">
                {{ scoped.row[column.prop] }}
              </div>
              <div v-else>
                {{ column.fieldMap[scoped.row[column.prop]] || '' }}
              </div>
            </template>
          </el-table-column>

          <el-table-column v-else-if="column.specialName && column.file" :prop="column.prop" :type="column.type"
            :show-overflow-tooltip="column['show-overflow-tooltip']" :label="column.label" :width="column.width"
            :align="column.align">
            <template #default="scoped">
              <el-popover placement="top-start" width="200" trigger="hover">
                <!-- <el-button>hover 激活</el-button> -->
                <div @click="openFile(item)" v-for="(item, index) in scoped.row[column.prop].split(',')" :key="index"
                  style="color:blue;cursor: pointer;">{{
                    item
                  }}
                </div>

                <div slot="reference" @click="$emit('special', column, scoped)" style="color:blue;cursor: pointer;">{{
                  scoped.row[column.prop]
                  }}
                </div>
              </el-popover>

            </template>
          </el-table-column>

          <el-table-column v-else-if="column.specialName && column.file2" :prop="column.prop" :type="column.type"
            :show-overflow-tooltip="column['show-overflow-tooltip']" :label="column.label" :width="column.width"
            :align="column.align">
            <template #default="scoped">
              <div style="display: flex;align-items: center;justify-content: center;">
                <!-- <div @click="openFile(item.filePath)" v-for="(item, index) in scoped.row[column.prop]" :key="index"
                style="color:blue;cursor: pointer;">
                {{ item.originalName }}
              </div>
              <div v-if="scoped.row[column.prop].length" style="color: red;word-break: keep-all;cursor: pointer;">删除</div> -->

                <planMakeUpload :projectId="scoped.row.projectId" :fileLists="scoped.row[column.prop]"></planMakeUpload>

              </div>
            </template>
          </el-table-column>

          <el-table-column v-else-if="column.specialName && column.children" :width="column.width" :label="column.label"
            :align="column.align">
            <el-table-column v-for="column2 in column.children" :prop="column2.prop" :type="column2.type"
              :label="column2.label" :width="column2.width" align="center" />

          </el-table-column>

          <!-- <el-table-column v-else-if="column.specialName && column.type == 1" :width="column.width" :label="column.label" :align="column.align">
        </el-table-column> -->

          <el-table-column v-else-if="column.specialName && column.type == 2" :width="column.width"
            :label="column.label" :align="column.align">
            <template slot-scope="scope">
              <div @click="btnTableActioin(scope.row, { name: column.specialName })">
                <span style="cursor: pointer;"
                  v-if="(scope.row.listClass == '' || scope.row.listClass == 'default') && (scope.row.cssClass == '' || scope.row.cssClass == null)">{{
                    scope.row[column.prop] }}</span>
                <el-tag style="cursor: pointer;" v-else
                  :type="scope.row.listClass == 'primary' ? '' : scope.row.listClass" :class="scope.row.cssClass">{{
                    scope.row[column.prop] }}</el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-else-if="column.specialName && column.pic" :prop="column.prop" :type="column.type" :label="column.label"
            :width="column.width" :align="column.align">
            <template #default="scoped">
              <el-image v-if="scoped.row[column.prop]" :src="prefixImgUrl+scoped.row[column.prop]"></el-image>
            </template>
          </el-table-column>

          <el-table-column v-else-if="column.specialName" :prop="column.prop" :type="column.type" :label="column.label"
            :width="column.width" :align="column.align">
            <template #default="scoped">
              <div @click="$emit('special', column, scoped)" style="color:blue;cursor: pointer;">{{
                scoped.row[column.prop]
                }}
              </div>
            </template>
          </el-table-column>

        </template>


        <el-table-column label="操作" :fixed="baseConfig.table.fixed" v-if="baseConfig.table.actionBtns.length"
          :width="baseConfig.table.actionWidth" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <template v-if="scope.row.examineStatus === 0 || !baseConfig.table.actionHideField">
              <template v-for="btn in baseConfig.table.actionBtns">
                <!-- 一个字段控制显示 -->
                <el-button :key="btn.name"
                  v-if=" typeof btn.preconditions === 'string' && ((scope.row[btn.preconditions] == btn.preconditionsValue))" size="mini"
                  type="text" :icon="btn.icon" @click="btnTableActioin(scope.row, btn)" v-has-btn="btn.permission">{{
                    btn.name }}</el-button>

               <!-- 多个字段控制显示 -->

                <el-button :key="btn.name"
                  v-if="typeof btn.preconditions === 'object' && (btn.preconditions.every((key,index) => scope.row[key] ==  btn.preconditionsValue[index])) " size="mini"
                  type="text" :icon="btn.icon" @click="btnTableActioin(scope.row, btn)" v-has-btn="btn.permission">{{
                    btn.name }}</el-button>
                <!-- 没有字段控制 -->
                <el-button :key="btn.name" v-if="!btn.preconditions" size="mini"
                  type="text" :icon="btn.icon" @click="btnTableActioin(scope.row, btn)" v-has-btn="btn.permission">{{
                    btn.name }}</el-button>


              </template>
            </template>
            <div v-if="!!baseConfig.table.actionHideField && scope.row.examineStatus === 1">
              {{ scope.row[baseConfig.table.actionHideField] }}
            </div>

          </template>
        </el-table-column>

      </el-table>

      <pagination v-show="baseConfig.table.tableParams.total > 0 && !baseConfig.table.tableParams.hidePagination"
        :total="baseConfig.table.tableParams.total" :page.sync="baseConfig.table.tableParams.page"
        :limit.sync="baseConfig.table.tableParams.limit" @pagination="pagination" />

    </el-card>

    <div v-if="baseConfig.moreMessage" style="text-align: right;padding-right: 30px;margin-top: 30px;"> {{
      baseConfig.moreMessage }}</div>

    <!-- 用户导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload ref="upload" :limit="1" accept=".xlsx, .xls" :headers="upload.headers"
        :action="upload.url + baseConfig.query.importUrl + '?type=' + baseConfig.defaultParams.type"
        :disabled="upload.isUploading" :on-progress="handleFileUploadProgress" :on-success="handleFileSuccess"
        :auto-upload="false" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
            @click="importTemplate">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import request from '@/utils/request'
import { getToken } from "@/utils/auth";
import dayjs from 'dayjs'
import { filePrefix } from '../../settings'
import planMakeUpload from '@/components/FileUpload/planMakeUpload.vue'
let that = this

export default {
  name: "basePage",
  // dicts: baseConfig.dicts,

  components: {
    planMakeUpload
  },

  props: {
    projectId: {
      type: [Number, String]
    },
    selectField: {
      type: String,
      default: 'servingId'
    },
    moreParams: {
      type: Object,
      default() {
        return {

        }
      }
    },
    baseConfig: {
      type: Object,
      default() {
        return {

        }
      }
    },
  },
  data() {
    return {
      prefixImgUrl: sessionStorage.getItem('prefixImgUrl'),

      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: {
          Authorization: "Bearer " + getToken(),
          Token: sessionStorage.getItem('token')
        },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API,
      },
      selectList: [],
      isFirst: true
    };
  },
  created() {
    if (this.baseConfig.table.getcolunms) {
      this.baseConfig.table.colunms = this.baseConfig.table.getcolunms(this.baseConfig.query.formParams.month || dayjs().format('YYYY-MM'))
    }

    this.getTableList()
  },

  watch: {
  },

  methods: {
    openFile(url) {
      if (!url) {
        return
      }

      window.open(filePrefix + url, '_blank')
    },

    /**
     * @获取表格数据
     */
    getTableList() {

      this.baseConfig.table.loading = true
      if (!this.isFirst) {
        this.$emit('getTableList')
      }
      this.isFirst = false
      let url = this.baseConfig.table.url
      if (this.baseConfig.table.isPathParams) {
        url = this.baseConfig.table.url + '/' + this.baseConfig.defaultParams[this.baseConfig.table.pathField]
      }


      let requestParams = {
        ...this.baseConfig.defaultParams,
        ...this.baseConfig.query.formParams,
        ...this.baseConfig.table.tableParams,
        ...this.$props.moreParams
      }

      // this.baseConfig.query.formParams

      this.baseConfig.query.formItemList.forEach(item => {
        if (item.rangeField && requestParams[item.field] && item.type === 'timePicker') {
          item.rangeField.forEach((field, index) => {
            requestParams[field] = requestParams[item.field][index]
          })
        }
      })

      let requestConfig = {
        url,
        method: this.baseConfig.table.method,
      }

      if (requestConfig.method === 'get' || requestConfig.method === 'GET') {
        requestConfig.params = requestParams
      } else {
        requestConfig.data = requestParams
      }

      request(requestConfig).then(res => {

        if (this.baseConfig.table.getcolunms) {
          this.baseConfig.table.colunms = this.baseConfig.table.getcolunms(this.baseConfig.query.formParams.month || dayjs().format('YYYY-MM'))
        }

        this.baseConfig.table.tableData = res[this.baseConfig.table.dataName || 'data'].map(item => {
          let systemTypeMap = {
            1: '掌上学',
            2: '风险管理系统'
          }
          if (item.type) {
            item.systemName = systemTypeMap[item.type]
          }

          return item
        })


        if (this.baseConfig.query.formItemList.some(item => item.isCustomer)) {
          // 只做了一个前端过滤的方法
          let customerObj = this.baseConfig.query.formItemList.find(item => item.isCustomer)

          this.baseConfig.table.tableData = this.baseConfig.table.tableData.map(item => {

            let target = this.baseConfig.table.customerData.find(item2 => item2.paymentId == item.paymentId)

            if (target && Object.keys(target).length) {
              item.orderClaimedState = target.orderClaimedState
            }

            return item
          })

          this.baseConfig.table.tableData = this.baseConfig.table.tableData.filter(item => {
            return !this.baseConfig.query.formParams[customerObj.field] || item[customerObj.field] == this.baseConfig.query.formParams[customerObj.field]
          })

        }

        this.baseConfig.table.tableParams.total = res.count || res.data.length
        this.baseConfig.table.loading = false

        setTimeout(() => {
          if (this.selectList.length > 0) {
            this.echo(res.rows || res.data)
          }
        }, 10);


      }).catch(err => {
        this.baseConfig.table.loading = false
      })
    },
    /**
     * @搜索栏按钮点击事件
     */
    searchBtnClick(btn) {
      if (btn.eventName == 'search') {
        this.$emit('queryBtn', btn)

        this.handleQuery()
      } else if (btn.eventName == 'reset') {
        this.resetQueryParams()
      } else if (btn.eventName == 'import') {
        this.handleImport()
      } else if (btn.eventName == 'export') {
        this.handleExport(btn)
      } else {
        this.$emit('queryBtn', btn)
      }

    },
    /**
     * @搜索事件
     */
    handleQuery() {
      this.baseConfig.table.tableParams.page = 1
      this.getTableList()
    },
    /**
     * @重置查询条件事件
     */

    resetQueryParams() {
      Object.keys(this.baseConfig.query.formParams).forEach(key => {
        this.baseConfig.query.formParams[key] = ""
      })

    },

    /**
     * @翻页事件
     */
    pagination(page) {
      this.getTableList()
    },

    /**
     * @表格操作事件
     */
    btnTableActioin(row, btn) {
      this.$emit('action', row, btn)
    },
    /** 导出按钮操作 */
    handleExport(btn) {

      if (btn.method === 'get' || btn.method === 'GET') {
        this.downloadGet(btn.url, {
          ...this.baseConfig.defaultParams,
          ...this.baseConfig.query.formParams,
          ...this.baseConfig.table.tableParams,
          ...this.$props.moreParams
        }, ``)
        return
      }


      this.download(btn.url, {
        ...this.baseConfig.defaultParams,
        ...this.baseConfig.query.formParams,
        ...this.baseConfig.table.tableParams,
        ...this.$props.moreParams
      }, ``)
    },

    /** 导入按钮操作 */
    handleImport() {
      this.upload.title = "导入";
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      this.download('system/user/importTemplate', {
      }, `user_template_${new Date().getTime()}.xlsx`)
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.msg + "</div>", "导入结果", { dangerouslyUseHTMLString: true });
      this.handleQuery();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },



    // 选择企业， 打钩或者取消
    handleSelectionChange(selecteds, row) {

      if (!this.selectList.includes(row[this.selectField])) {
        // 回显数据里没有本条， 把这条加进来（选中）
        this.selectList.push(row[this.selectField])
      } else {
        // 回显数据有本条，把这条数据删除（取消选中）
        this.selectList.splice(this.selectList.indexOf(row[this.selectField]), 1)
      }

    },
    // 全选、取消全选
    handleAllChange(selects) {
      if (selects.length > 0) {
        selects.forEach(item => {
          if (!this.selectList.includes(item[this.selectField])) {
            this.selectList.push(item[this.selectField])
          }
        })
      } else {
        this.baseConfig.table.tableData.forEach(item => {
          this.selectList.forEach((id, index) => {
            if (item[this.selectField] === id) {
              this.selectList.splice(index, 1)
            }
          })
        })
      }

    },
    echo(data) {
      let rows = []
      data.forEach(item => {
        this.selectList.forEach(item2 => {
          if (item[this.selectField] === item2) {
            rows.push(item)
          }
        })
      })
      this.toggleSelection(rows)
    },
    // 在获取企业数据下调用
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep .table-card .el-card__body {
  padding: 0;
}
</style>
